import React from 'react';
import CpscCoreForm from 'components/CpscCoreForm';
import { PgaFormBaseProps } from 'types';
import { StyledCpscFormDiv } from './styles';

export interface CpscFormProps extends PgaFormBaseProps {
  packagingLevelsOverride?: number;
}

const CpscForm: React.FC<CpscFormProps> = ({
  fullNamePath,
  localNamePath,
  readOnly,
  required,
  disabled,
}) => {
  return (
    <StyledCpscFormDiv>
      <CpscCoreForm
        fullNamePath={fullNamePath}
        localNamePath={localNamePath}
        readOnly={readOnly}
        required={required}
        disabled={disabled}
      />
    </StyledCpscFormDiv>
  );
};

export default CpscForm;
